module.exports = __webpack_public_path__ + "img/popup-valentines.5c55737d.png";